import { render } from "./SendersManager.vue?vue&type=template&id=080e8085&ts=true"
import script from "./SendersManager.vue?vue&type=script&lang=ts"
export * from "./SendersManager.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./SendersManager.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__